<template>
    <div class="infobox infobox-border">
        <div class="infobox-headline">
            <strong>Arbeitsverhältnis</strong>
        </div>

        <template v-for="(workStateEntry, index) in workStateData">
            <hr v-if="index" class="small"/>

            <div class="row">
                <div class="col-sm-6">
                    <strong>Vertragsabschluss</strong>
                    <div>{{workStateEntry.contract_date ? dateHelper('d.m.Y', workStateEntry.contract_date) : 'Keine Angabe'}}</div>
                    <div class="spacer spacer-5"/>
                </div>

                <div class="col-sm-6">
                    <strong>Arbeitsbeginn</strong>
                    <div>{{workStateEntry.since ? dateHelper('d.m.Y', workStateEntry.since) : 'Keine Angabe'}}</div>
                    <div class="spacer spacer-5"/>
                </div>

                <div class="col-sm-6" v-bind="insightAttributes" v-tooltip>
                    <strong>Wochenstunden</strong>
                    <div>
                        {{workStateEntry.weekly_hours}}
                    </div>
                    <div class="spacer spacer-5"/>
                </div>

                <div class="col-sm-6" v-bind="insightAttributes" v-tooltip>
                    <strong>Urlaubstage</strong>
                    <div>{{workStateEntry.vacation_days}}</div>
                    <div class="spacer spacer-5"/>
                </div>

                <div class="col-12" v-bind="insightAttributes" v-tooltip>
                    <strong>Arbeitszeitmodell</strong>
                    <div class="flex gap-5 flex-wrap">
                        <div>{{workStateEntry.work_days_default ? workStateEntry.work_days_default : workStateEntry.work_days_custom}}-Tage-Woche</div>
                        <div v-if="workStateEntry.settings_days && workStateEntry.settings_days.length">
                            <div v-for="weekDays in workStateEntry.settings_days">
                                ({{weekDays}})
                            </div>
                        </div>
                    </div>
                    <div class="spacer spacer-5"/>
                </div>
            </div>
            <hr>
            <div class="text-center">
                <router-link :to="{name: 'employee-view', params: {id: employeeId}}" class="button button-secondary spacer-10">
                    Zum Mitarbeiterprofil
                </router-link>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
    import {INSIGHT_ATTRIBUTES} from '@/library/modules/employee';
    import dateHelper from '@/utils/portuna/dateHelper';
    import {computed} from 'vue';
    import {useStore} from 'vuex';

    const store = useStore();

    const props = defineProps<{
        employeeId: number;
        workStateData: WorkStateHistoryCompleteEntry[];
    }>();

    const insightAttributes = computed(() => store.getters.employeeConfiguration.version ? {} : INSIGHT_ATTRIBUTES);
</script>